import React from "react";
import {
  TextAreaStyled,
  TextAreaSectionStyled,
  SpanTextArea,
  TextAreaContainer,
  TextAreaLabelStyled
} from "./TextArea.style";

interface IProps {
  attributes?: any;
  disabled?: boolean;
  error: boolean;
  errorMessage: string;
  htmlFor: string;
  id: string;
  inputLabel: string;
  name: string;
  onBlur: (event: any) => void;
  onChange: (event: any) => void;
  placeholder: string;
  readOnly?: boolean;
  required: boolean;
  showErrorOnInput: boolean;
  type: string;
  value?: string;
}

const TextArea: React.FC<IProps> = ({
  attributes,
  disabled,
  error,
  htmlFor,
  id,
  inputLabel,
  name,
  onBlur,
  onChange,
  placeholder,
  readOnly,
  required,
  type,
  value
}: IProps) => {
  return (
    <TextAreaSectionStyled>
      {inputLabel && (
        <TextAreaLabelStyled htmlFor={htmlFor}>
          {inputLabel}
        </TextAreaLabelStyled>
      )}

      <TextAreaContainer>
        {type === "icon" && (
          <SpanTextArea styleType={type}>
            <img src={attributes?.icon} alt="" />
          </SpanTextArea>
        )}

        <TextAreaStyled
          disabled={disabled}
          error={error}
          id={id}
          name={name}
          onBlur={(event: any): void => {
            !readOnly && !disabled && onBlur(event);
          }}
          onChange={(event: any): void => {
            !readOnly && !disabled && onChange(event);
          }}
          placeholder={placeholder}
          readOnly={readOnly}
          required={required}
          styleType={type}
          value={value || ""}
        />
      </TextAreaContainer>
    </TextAreaSectionStyled>
  );
};

export default TextArea;
